import { render, staticRenderFns } from "./Corporate.vue?vue&type=template&id=2678da14&"
import script from "./Corporate.vue?vue&type=script&lang=js&"
export * from "./Corporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports